import { boronClient, makeFormData } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useUpdateKarteCache } from "../../../hooks/http/useFetchKarte";
import { useUpdateSectionKartesCache } from "../../../hooks/http/useFetchSectionKartes";
import { useUpdateStudentKartesCache } from "../../../hooks/http/useFetchStudentKartes";
import KarteInterface from "../../../interfaces/KarteInterface";

// ファイルを追加する場合はfileを指定し、削除する場合はidと_destroyを指定する
type KarteAttachment =
  | {
      file: File;
    }
  | {
      id: string;
      _destroy: "true";
    };

export type UpdateKarteParams = {
  name: string;
  comment: string;
  karte_attachments_attributes?: KarteAttachment[];
  karte_image_attachments_attributes?: KarteAttachment[];
};

export const useUpdateStudentKarte = ({
  studentId,
  karteId,
}: {
  studentId: string;
  karteId: string;
}) => {
  const { updateKarteCache: updateSectionKartesCache } =
    useUpdateSectionKartesCache();
  const { updateKarteCache: updateStudentKartesCache } =
    useUpdateStudentKartesCache();
  const { updateKarteCache } = useUpdateKarteCache({
    studentId,
    karteId,
  });

  return useBoronMutation<{ karte: KarteInterface }, UpdateKarteParams>(
    async (params) =>
      await boronClient.PATCH(
        "/api/v1/students/{student_id}/kartes/{karte_hashid}",
        {
          params: { path: { student_id: studentId, karte_hashid: karteId } },
          body: {
            karte: params,
          },
          bodySerializer: makeFormData,
        },
      ),
    {
      onSuccess: ({ karte }) => {
        const sectionId = karte.student.section.id;
        updateSectionKartesCache(sectionId, karte);
        updateStudentKartesCache(studentId, karte);
        updateKarteCache(karte);
      },
    },
  );
};
